import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import * as Logger from 'js-logger';
import template from './sidebar.vue';
import * as Store from '../../store';
import $ from 'jquery';

@Component({
    mixins: [template],
})

export default class Sidebar extends Vue {

    created() {
        // When the component gets created.
    }

    mounted() {

    }

    get isLoggedIn(): boolean {
        return Store.readLoggedInState(this.$store);
    }

    get loggedUser(): boolean {
        return Store.readLoggedInUser(this.$store);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/sidebar/index.ts